/**
 * Animation 
 */
document.addEventListener('DOMContentLoaded', () => {
  const elToAnimate = document.querySelectorAll('.toAnimate')
  elToAnimate.forEach(el => {
    // Check if this element is in viewport
    if (isElInView(el)) {
      el.classList.remove('toAnimate')

      // Add animation delay if needed
      const delay = el.dataset.animationDelay
      if (delay) {
        el.style.animationDelay = delay
      }

      el.classList.add('animate')
    }
  })

  window.addEventListener('scroll', () => {
    const elToAnimate = document.querySelectorAll('.toAnimate')
    elToAnimate.forEach(el => {
      // Check if this element is in viewport
      if (isElInView(el)) {
        el.classList.remove('toAnimate')

        // Add animation delay if needed
        const delay = el.dataset.animationDelay
        if (delay) {
          el.style.animationDelay = delay
        }

        el.classList.add('animate')
      }
    })
  })
})

/**
 * Check if a HTML element is in the viewport
 */
const isElInView = el => {
  const scroll = window.scrollY || window.pageYOffset
  const boundsTop = el.getBoundingClientRect().top + scroll

  const viewport = {
    top: scroll,
    bottom: scroll + window.innerHeight
  }

  const bounds = {
    top: boundsTop,
    bottom: boundsTop + el.clientHeight
  }

  return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
        || (bounds.top <= viewport.bottom && bounds.top >= viewport.top)
}




